import { Inject } from '@rxdi/core';
import { Component, html, LitElement, property } from '@rxdi/lit-html';

import { TranslateService } from './translate.service';

/**
 * @customElement translate-dropdown
 */
@Component({
  selector: 'translate-dropdown',
  template(this: TranslateComponent) {
    const template = this.translateService.config.languages.map(
      (language) => html`<bx-dropdown-item value=${language}>${language}</bx-dropdown-item> `
    );
    return html`
      <bx-dropdown
        @bx-dropdown-selected=${(e: CustomEvent) => {
          this.translateService.changeLanguage(e.detail.item.value);
          if (this.refreshPage) {
            location.reload();
          }
        }}
        trigger-content=${this.translateService.currentLanguage.getValue()}
      >
        ${template}
      </bx-dropdown>
    `;
  },
})
export class TranslateComponent extends LitElement {
  @Inject(TranslateService)
  private translateService: TranslateService;

  @property({ type: Boolean })
  refreshPage = false;
}
